export const LOG_LEVEL_ERROR = 'ERROR';
export const LOG_LEVEL_INFO = 'INFO';
